<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <form action="" class="" @submit.prevent="validateForm" novalidate>
              <div class="row">

                <FormInput name="ContactPolicyNumber" type="text" label="เลขกรมธรรม์"
                  v-model="values.ContactPolicyNumber" placeholder="เลขกรมธรรม์" @validate="validate"
                  :error="errors.ContactPolicyNumber" :requireField="false" formGroupClass="form-group col-sm-4" />

                <FormInput name="Firstname" type="text" label="ชื่อผู้เอาประกัน" v-model="values.Firstname"
                  placeholder="ชื่อผู้เอาประกัน" @validate="validate" :error="errors.Firstname" :requireField="false"
                  formGroupClass="form-group col-sm-4" />

                <FormInput name="Lastname" type="text" label="นามสกุลผู้เอาประกัน" v-model="values.Lastname"
                  placeholder="นามสกุลผู้เอาประกัน" @validate="validate" :error="errors.Lastname" :requireField="false"
                  formGroupClass="form-group col-sm-4" />
              </div>
              <div class="row mt-0 mb-3 mx-0">
                <div class="col-sm-8 p-0">
                  <button type="submit" class="btn btn-primary mr-2">
                    <i class="fe-search"></i>
                    ค้นหางาน
                    <div v-show="isBusy" class="spinner-border spinner-border-sm ml-2" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </button>
                  <button type="button" class="btn btn-outline-secondary" @click="resetFilter">รีเซ็ต</button>
                </div>
                <!-- <div class="col-sm-4 p-0 text-right">
                  <button type="button" class="btn btn-secondary" @click="downloadExcel" target="_blank"
                    :disabled="isDownload">
                    <b-spinner small v-if="isDownload"></b-spinner>
                    Download Excel</button>
                </div> -->
              </div>
            </form>

            <!-- Table -->
            <b-table id="my-table" ref="table" class="table table-centered table-striped border mt-2"
              :filter="checkFilter" :fields="fields" :items="getDataTable" :per-page="values.PerPage"
              :current-page="values.CurrentPage" :busy="isBusy" small>

              <template v-slot:cell(actions)="row">
                <button class="btn btn-info btn-sm" @click="onClickShowDetail(row.item)">
                  <i class="fe-search"></i>
                </button>

              </template>
            </b-table>
            <b-pagination v-model="values.CurrentPage" :total-rows="TotalRows" :per-page="values.PerPage"
              aria-controls="my-table"></b-pagination>
            <!-- end table -->

          </div>
        </div>
      </div>
    </div>

    <b-modal size="xl" id="bv-modal-detail" hide-footer small>
      <template #modal-title>
        รายละเอียด
      </template>
      <div class="d-block">
        <div class="row p-1">
          <div class="col-md-3 text-md-right">ชื่อผู้เอาประกันภัย:</div>
          <div class="col-md-3">{{ displayData.Firstname }} {{ displayData.Lastname }}</div>
          <div class="col-md-2 text-md-right">กรมธรรม์เลขที่:</div>
          <div class="col-md-2">{{ displayData.ContactPolicyNumber }}</div>
          <div class="col-md-1 text-md-right">ปีที่:</div>
          <div class="col-md-1">{{ displayData.Year }}</div>
        </div>

        <div class="row p-1">
          <div class="col-md-3 text-md-right">วันที่ชำระเงิน:</div>
          <div class="col-md-3">{{ displayData.PaymentAt != null ? dateFormat(displayData.PaymentAt) : '-' }}</div>
        </div>

        <div class="row p-1">
          <div class="col-md-3 text-md-right">วันที่กรมธรรม์มีผลคุ้มครอง":</div>
          <div class="col-md-3">{{ displayData.ContactSigned != null ? dateFormat(displayData.ContactSigned) : '-' }}
          </div>
        </div>

        <div class="row p-1">
          <div class="col-md-3 text-md-right">วันที่ครบกำหนดชำระงวดถัดไป:</div>
          <div class="col-md-2" v-bind:class="{ 'text-danger': isOverDue }">{{ displayData.DueDateAt != null
            ?
            dateFormat(displayData.DueDateAt) : '-' }}</div>
        </div>
        <div class="row p-1">
          <div class="col-md-3 text-md-right">ชำระเบี้ยประกันแบบ:</div>
          <div class="col-md-3">{{ displayData.PaymentTypeTxt }}</div>
        </div>
        <div class="row p-1">
          <div class="col-md-3 text-md-right">เบี้ยประกันภัยรวม:</div>
          <div class="col-md-2">{{ moneyFormatFull(displayData.Amount) }} บาท</div>
        </div>

        <div class="row p-1">
          <div class="col-md-12">
            <Label>ข้อมูลสัญญา</Label>

            <table class="table table-centered table-striped border mt-2">
              <thead>
                <tr>
                  <th>บริษัท</th>
                  <th>ชื่อสัญญา</th>
                  <th>ประเภท</th>
                  <th class="text-right">เบี้ย</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="pack in CurrentOrderPackages" :key="pack.OrderPackageId">
                  <td>{{ displayData.InsuranceTxt }}</td>
                  <td>{{ pack.ContractName }}</td>
                  <td>{{ pack.ContractType == 1 ? 'สัญญาหลัก' : 'สัญญาเพิ่มเติม' }}</td>
                  <td class="text-right">{{ moneyFormatFull(pack.Price) }}</td>
                </tr>
                <tr v-if="!CurrentOrderPackages || CurrentOrderPackages.length === 0">
                  <td colspan="100%" class="table-empty-note">ไม่มีข้อมูล</td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>

        <div class="row p-1">
          <div class="col-md-12">
            <Label>ข้อมูลการจ่ายเงิน</Label>

            <table class="table table-centered table-striped border mt-2">
              <thead>
                <tr>
                  <th>งวดที่</th>
                  <th>วันครบกำหนดชำระ</th>
                  <th>วันที่ชำระเบี้ย</th>
                  <th class="text-right">ชำระ</th>
                  <th class="text-right">ยอดโอนค่าคอมมิชชั่น</th>
                  <th class="text-center">วันที่จ่าย(คอม)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="pay in CurrentOrderPayment" :key="pay.Period">

                  <td>{{ pay.Period }}</td>
                  <td class="text-left">{{ dateFormat(pay.DueDateAt) }}</td>
                  <td class="text-left">{{ pay.PaymentAt == null ? '' : dateFormat(pay.PaymentAt) }}</td>
                  <td class="text-right">{{ pay.Payment == 0 ? '' : moneyFormatFull(pay.Payment) }}</td>
                  <td class="text-right">{{ pay.CommissionAt == null ? '' : moneyFormatFull(pay.ComTotal) }}</td>
                  <td class="text-center">

                    <span v-if="pay.CommissionAt != null && pay.CommissionStatus == 1" class="bg-success text-white">{{
                      dateFormat(pay.CommissionAt) }}</span>
                    <span
                      v-else-if="pay.CommissionStatus == 0 && pay.CommissionAt != null && $dayjs(pay.BrokerCardExpire).isBefore($dayjs())"
                      class="bg-danger text-white">บัตรนายหน้าหมดอายุ</span>
                    <span v-else-if="pay.CommissionStatus == 0 && pay.CommissionAt != null"
                      class="bg-warning text-white">กำลังดำเนินการ</span>

                  </td>
                </tr>
                <tr v-if="!CurrentOrderPayment || CurrentOrderPayment.length === 0">
                  <td colspan="100%" class="table-empty-note">ไม่มีข้อมูล</td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>
      </div>

    </b-modal>

  </Layout>
</template>

<script>

import Layout from '@/components/layouts/main'
import PageHeader from '@/components/page-header'

let self;

/**
 * Customers component
 */
export default {
  page: {
    title: 'ตรวจสอบงาน',
    meta: [{ name: 'description' }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    var yup = this.yup
    return {
      title: 'ตรวจสอบงาน',
      items: [
        {
          text: 'SKLife',
          to: { name: 'home' }
        },
        {
          text: 'ตรวจสอบงาน',
          active: true
        },
      ],
      MasterInsuranceComp: [],
      values: {
        ContactPolicyNumber: "",
        Firstname: "",
        Lastname: "",
        PerPage: 10,
        CurrentPage: 1,
      },
      errors: {
        ContactPolicyNumber: "",
        Firstname: "",
        Lastname: "",
      },
      FormSchema: yup.object().shape({
        ContactPolicyNumber: yup.string().nullable(),
        Firstname: yup.string().test('empty-check', 'ค้นหาไม่น้อยกว่า 4 ตัวอักษร', Firstname => !Firstname || Firstname.length >= 4),
        Lastname: yup.string().test('empty-check', 'ค้นหาไม่น้อยกว่า 4 ตัวอักษร', Lastname => !Lastname || Lastname.length >= 4),
      }),
      fields: [
        {
          key: 'Name', label: 'ผู้เอาประกัน', sortable: true, class: '',
          formatter: (value, key, item) => {
            return item.Firstname + ' ' + item.Lastname
          }
        },
        {
          key: 'ContactPolicyNumber', label: 'กรมธรรม์', sortable: true, class: 'text-nowrap',
          formatter: (value, key, item) => {
            return item.ContactPolicyNumber;
          }
        },
        {
          key: 'ContactSigned', label: 'วันที่อนุมัติ', sortable: true, sortDirection: 'desc',
          formatter: (value, key, item) => {
            if (value == '')
              return '';
            else
              return self.dateFormat(value)
          }
        },
        {
          key: 'Year', label: 'ปี', sortable: true,
          formatter: (value, key, item) => {
            return item.Year;
          }
        },
        {
          key: 'Period', label: 'งวด', sortable: true,
          formatter: (value, key, item) => {
            return item.Period;
          }
        },
        {
          key: 'PaymentTypeTxt', label: 'ชำระเบี้ยแบบ', sortable: true,
          formatter: (value, key, item) => {
            return value;
          }
        },
        {
          key: 'PaymentAt', label: 'วันที่ชำระเงิน', sortable: true, class: 'text-nowrap',
          formatter: (value, key, item) => {
            if (value == null)
              return '';
            else
              return self.dateFormat(value)
          }
        },
        {
          key: 'DueDateAt', label: 'งวดถัดไป', sortable: true,
          formatter: (value, key, item) => {
            if (value == null)
              return '';
            else
              return self.dateFormat(value)
          }
        },
        {
          key: 'Payment', label: 'เบี้ย/งวด', sortable: true, class: 'text-right',
          formatter: (value, key, item) => {
            return self.moneyFormatFull(value)
          }
        },
        {
          key: 'Amount', label: 'เบี้ยรวม', sortable: true, class: 'text-right',
          formatter: (value, key, item) => {
            return self.moneyFormatFull(value)
          }
        },

        { key: 'actions', label: 'Actions', class: 'text-nowrap' }

      ],
      isFirstLoad: true,
      isDownload: false,
      isBusy: false,
      checkFilter: '1',
      perPage: 10,
      currentPage: 1,
      TotalRows: 0,
      displayData: [],
      CurrentOrderPackages: [],
      CurrentOrderPayment: [],
      isOverDue: false,
      dataMasterBranchTeam: [],
      dataMasterBranch: [],
      dataMasterBranchTeamOptions: [],
      dataMasterBranchOptions: [],
      dataMasterDateCriteria: [
        { id: 'ContactCreateDate', value: 'วันแจ้งงาน' },
        { id: 'ContactSigned', value: 'วันเริ่มสัญญา' },
        { id: 'CommissionAt', value: 'วันที่คืนคอมฯ' },
        { id: 'DueDateAt', value: 'วันครบกำหนดชำระงวดถัดไป' }],
      dataDueDateIn: [{ id: '15', value: '15 วัน' }, { id: '30', value: '30 วัน' }, { id: '60', value: '60 วัน' }],
    }
  },
  async created() {
    self = this;
    self.MasterInsuranceComp = self.$store.state.Insurances.map((c) => { return { id: c.Id, value: c.FullName } });
    // self.getMasterData();

    console.log(self.$route.params.insuranceid);

    // if (self.$route.params.insuranceid) {
    //   self.values.InsuranceComp = self.$route.params.insuranceid;
    // }

    // if (self.$route.params.status) {
    //   self.values.IsPendingStatus = self.$route.params.status == '8888' ? 'Y' : 'N';
    //   self.isFirstLoad = false;
    //   self.checkFilter = this.$dayjs();
    // }

  },
  methods: {
    validateForm() {
      this.FormSchema
        .validate(this.values, { abortEarly: false })
        .then(() => {
          // this.getAllData();
          // self.filter = {
          //   AgentId: self.values.AgentId,
          //   Firstname: self.values.Firstname,
          //   Lastname: self.values.Lastname
          // }
          self.checkFilter = this.$dayjs();
          console.log('test')
        })
        .catch(err => {
          err.inner.forEach(error => {
            this.errors = { ...this.errors, [error.path]: error.message };
          });
        });
    },
    validate(field) {
      this.FormSchema
        .validateAt(field, this.values)
        .then(() => {
          this.errors[field] = "";
        })
        .catch(err => {
          this.errors[err.path] = err.message;
        });
    },
    async getDataTable(ctx) {
      if (self.isFirstLoad) {
        self.isFirstLoad = false;
        return;
      }

       if (self.values.ContactPolicyNumber == '' && self.values.Firstname == '' && self.values.Lastname == '') {
        self.$swal({
          title: 'แจ้งเตือน',
          text: 'กรุณาป้อนข้อมูลอย่างน้อย 1 ช่อง',
          icon: 'warning',
        });
        return;
      }

      try {
        self.isBusy = true;

        const config = {
          headers: { Authorization: `Bearer ${self.$store.state.Admin.Token}` },
          params: self.values
        };

        const response = await self.axios.get(process.env.VUE_APP_OFFICEAPI_URL + `/api/order/getordercheck`, config)
        self.isBusy = false
        console.log(response.data, response.data.length)
        self.TotalRows = response.data.TotalRecords;
        return response.data.Data
      } catch (error) {
        self.isBusy = false
        return []
      }
    },
    resetFilter() {
      console.log('Reset')
      this.values = {
        ContactPolicyNumber: "",
        Firstname: "",
        Lastname: "",
        PerPage: 10,
        CurrentPage: 1,
      };

      self.FormSchema = self.yup.object().shape({
        ContactPolicyNumber: self.yup.string().nullable(),
        Firstname: self.yup.string().test('empty-check', 'ค้นหาไม่น้อยกว่า 4 ตัวอักษร', Firstname => !Firstname || Firstname.length >= 4),
        Lastname: self.yup.string().test('empty-check', 'ค้นหาไม่น้อยกว่า 4 ตัวอักษร', Lastname => !Lastname || Lastname.length >= 4),
      });

      // this.errors["DateStart"] = "";
      // this.errors["DateEnd"] = "";
      //self.checkFilter = this.$dayjs();
    },

    async onClickShowDetail(currentRow) {

      console.log(currentRow)

      let date1 = this.$dayjs(currentRow.DueDateAt);
      let date2 = this.$dayjs();
      self.isOverDue = date1.diff(date2) < 0;

      const config = {
        headers: { Authorization: `Bearer ${this.$store.state.Admin.Token}` }
      };

      await this.axios.get(process.env.VUE_APP_OFFICEAPI_URL + '/api/orderpackageyear/getorderpackageyear/' + currentRow.Id + '/' + currentRow.Year, config)
        .then(function (res) {
          if (res.status == 200) {
            console.log(res)
            self.CurrentOrderPackages = res.data

            console.log('aaaa', res.data)
          } else {
            self.$swal('เกิดข้อผิดพลาด1');
          }
        })
        .catch(function (error) {
          console.log(error)
          self.$swal('เกิดข้อผิดพลาด2');
        });

      await this.axios.get(process.env.VUE_APP_OFFICEAPI_URL + '/api/order/getordercheckpayment?OrderId=' + currentRow.Id, config)
        .then(function (res) {
          if (res.status == 200) {
            console.log(res)
            self.CurrentOrderPayment = res.data

            self.displayData = currentRow;
            self.$bvModal.show('bv-modal-detail');

            console.log('bbbb', res.data)
          } else {
            self.$swal('เกิดข้อผิดพลาด1');
          }
        })
        .catch(function (error) {
          console.log(error)
          self.$swal('เกิดข้อผิดพลาด2');
        });
    },

    // downloadExcel() {
    //   try {
    //     self.isDownload = true;
    //     const config = {
    //       headers: { Authorization: `Bearer ${self.$store.state.Admin.Token}` },
    //       responseType: 'blob',
    //       params: self.values
    //     };
    //     this.axios.get(process.env.VUE_APP_OFFICEAPI_URL + '/api/order/exportexcelgetordercheck', config)
    //       .then(function (res) {
    //         if (res.status == 200) {
    //           console.log(res)
    //           const filename = 'Job_Inspect_' + self.$dayjs().format('YYYY_MM_DD_HH_mm_ss') + '.xlsx';
    //           const blob = new Blob([res.data], { type: 'application/xlsx' })
    //           const link = document.createElement('a')
    //           link.href = URL.createObjectURL(blob)
    //           link.download = filename
    //           link.click()
    //           URL.revokeObjectURL(link.href)
    //         } else {
    //           self.$swal('เกิดข้อผิดพลาด1');
    //         }
    //         self.isDownload = false;
    //       })
    //       .catch(function (error) {
    //         self.$swal('เกิดข้อผิดพลาด2');
    //         self.isDownload = false;
    //       });
    //   } catch (error) {
    //     return null
    //   }
    // }

  },
}
</script>
